import { HTTPClient } from "./Client";

const SuporteApi = {

    async responderSuporteAsync(suporteId, resposta) {
        const responderSuporte = {
            SuporteId: suporteId,
            Resposta: resposta,
        };

        await HTTPClient.put(`/Suporte/ResponderSuporte`, responderSuporte);
    },

    async obterSuportePorIdAsync(suporteId) {

        const response = await HTTPClient.get(`/Suporte/ObterSuportePorId/${suporteId}`);
        return response.data;
    },

    async listarTiposSuporteAsync() {
        const response = await HTTPClient.get(`/Suporte/ListarTiposSuporte`);
        return response.data;
    },


    async listarSuportesComPaginacaoAsync(pagina, tipoSuporte, respondido, ticket) {
        const suportesComPaginacao = {
            Pagina: pagina,
            TipoSuporte: Number(tipoSuporte),
            Respondido: respondido,
            Ticket: ticket
        };

        const response = await HTTPClient.post(`/Suporte/ListarSuportesComPaginacao`, suportesComPaginacao);
        return response.data;
    },
}

export default SuporteApi;